// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w4ZU","col":"styles_col__1lIds"};